import axios from 'axios'

const baseURL = process.env.VUE_APP_URL_API || 'http://localhost/axen_app_api/'

export const api = axios.create({
  baseURL,
  timeout: 60000,
})
